import { print } from "graphql";
import { BaseAPI } from "@/api/base.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { map } from "rxjs/operators";
import { Linha } from "@/models/linha";
import { Veiculo } from "@/models/veiculo";
import { plainToClass } from "class-transformer";
import { of, Observable } from "rxjs";
import { VUE_APP_SIT_API_URL, API_URL_SERVICE } from "@/commons/config";

const veiculosQuery = require("@/query/licenca-especial/ListarVeiculos.graphql");

export class VeiculoAPI extends BaseAPI<Veiculo> {
  constructor() {
    super();
  }

  public findBy(cnpj: string, token: string): Observable<Veiculo[]> {
    return this.axios
      .post(`${this.graphqlUrl}`, {
        query: print(veiculosQuery),
        variables: {
          cnpj,
          token
        }
      })
      .pipe(
        map((data: any) => {
          const { veiculos } = data;
          return plainToClass(Veiculo, veiculos as Object[]);
        })
      );
  }

  public findById(veiculoId: number): AxiosObservable<Veiculo> {
    return this.axios
      .post(`${VUE_APP_SIT_API_URL}/veiculos/veiculo`, {
        id: veiculoId
      })
      .pipe(
        map((data: any) => {
          if (!data.veiculo) {
            throw data.mensagem;
          }
          return data.veiculo;
        })
      );
  }

  public findByCnpjPaca(cnpj: string, placa: string): AxiosObservable<Veiculo> {
    return this.axios
      .post(`${VUE_APP_SIT_API_URL}/veiculos/veiculo`, {
        cnpj,
        placa
      })
      .pipe(
        map((data: any) => {
          if (!data.veiculo) {
            throw data.mensagem;
          }
          return data.veiculo;
        })
      );
  }

  public findByVeiculoTransportadora(
    veiculoTransportadoraId: number
  ): AxiosObservable<Veiculo> {
    return this.axios
      .post(`${this.apiUrl}/api/licenca/veiculoTransportadora`, {
        id: veiculoTransportadoraId
      })
      .pipe(
        map((data: any) => {
          return data;
        })
      );
  }
}
